// SAMURAI — Brand rosters and marquee logos
// `logo` = local file (preferred); `domain` = Clearbit fallback; `name` = final text fallback.

export const BRAND_LOGOS = [
  { name: "GPay", logo: "/brand/gpay.png", domain: "pay.google.com" },
  { name: "Closeup", domain: "closeuptoothpaste.com" },
  { name: "LUX", logo: "/brand/lux.png", domain: "lux.com" },
  { name: "Godrej Properties", logo: "/brand/godrej.png", domain: "godrejproperties.com" },
  { name: "Glow & Lovely", domain: "glowandlovely.in" },
  { name: "Love Beauty and Planet", logo: "/brand/lbp.png", domain: "lovebeautyandplanet.com" },
  { name: "JAWA", logo: "/brand/jawa.png", domain: "jawamotorcycles.com" },
  { name: "BRU", domain: "brucoffee.in" },
  { name: "Horlicks", logo: "/brand/horlicks.png", domain: "horlicks.in" },
  { name: "Kissan", logo: "/brand/kissan.png", domain: "kissan.in" },
  { name: "3 Roses Elaichi", logo: "/brand/3roses.png", domain: "3roses.co.in" },
  { name: "Doceree", domain: "doceree.com" },
  { name: "OZiva", logo: "/brand/oziva.png", domain: "oziva.in" },
  { name: "VS Mani & Co.", domain: "vsmaniandco.com" },
  { name: "GoKwik", logo: "/brand/gokwik.png", domain: "gokwik.co" },
  { name: "Comfort", logo: "/brand/comfort.png", domain: "comfortfabricconditioner.com" },
  { name: "Woodland", logo: "/brand/woodland.png", domain: "woodlandworldwide.com" },
  { name: "Pears", logo: "/brand/pears.png", domain: "pearssoap.com" },
  { name: "Upakarma Ayurveda", logo: "/brand/upakarma.png", domain: "upakarmaayurveda.com" },
  { name: "PM Cona", logo: "/brand/pm-cona.png" },
  { name: "Emami", logo: "/brand/emami.png", domain: "emamigroup.com" },
  // Agencies (merged into the main grid)
  { name: "Omnicom", logo: "/brand/omnicom.png", domain: "omnicomgroup.com" },
  { name: "Ogilvy", logo: "/brand/ogilvy.png", domain: "ogilvy.com" },
  { name: "Toaster", domain: "toaster.co" },
  { name: "Punt", logo: "/brand/punt.png", domain: "puntpartners.in" },
  { name: "TILT Brand Solutions", logo: "/brand/tilt.png", domain: "tiltbrandsolutions.com" },
  { name: "Talented", logo: "/brand/talented.png", domain: "talented.agency" },
  { name: "Curativity", logo: "/brand/curativity.png", domain: "thecurativity.com" },
];

// Legacy exports (kept for any lingering imports)
export const PARTNERS_CLIENTS = BRAND_LOGOS.slice(0, 19).map((b) => b.name);
export const PARTNERS_AGENCIES = BRAND_LOGOS.slice(19).map((b) => b.name);
export const PARTNERS = PARTNERS_CLIENTS;

// Landing marquee — real brand logos looping continuously
export const MARQUEE_LOGOS = [
  "/brand/horlicks.png",
  "/brand/kissan.png",
  "/brand/godrej.png",
  "/brand/comfort.png",
  "/brand/emami.png",
  "/brand/woodland.png",
  "/brand/pears.png",
  "/brand/lux.png",
  "/brand/tilt.png",
  "/brand/talented.png",
  "/brand/omnicom.png",
  "/brand/curativity.png",
  "/brand/gpay.png",
  "/brand/ogilvy.png",
  "/brand/jawa.png",
  "/brand/oziva.png",
];
